var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-manualEntry"},[_c('Input',{attrs:{"label":"发票代码","placeholder":"请输入10或12位发票代码","type":"text","maxlength":"12","reg":[
          {
            pattern: /^[0-9a-zA-Z]{10,12}$/,
            message: '请输入正确的发票代码',
            required: true
          }
        ]},model:{value:(_vm.form.invoiceCode),callback:function ($$v) {_vm.$set(_vm.form, "invoiceCode", $$v)},expression:"form.invoiceCode"}}),_c('Input',{attrs:{"label":"发票号码","placeholder":"请输入8位发票号码","maxlength":"8","type":"text","reg":[
          {
            pattern: /^[0-9a-zA-Z]{8}$/,
            message: '请输入正确的发票号码',
            required: true
          }
        ]},model:{value:(_vm.form.invoiceNumber),callback:function ($$v) {_vm.$set(_vm.form, "invoiceNumber", $$v)},expression:"form.invoiceNumber"}}),(_vm.isShowMoney)?_c('Input',{attrs:{"label":"合计金额（不含税）","placeholder":"请输入不含税金额","type":"text","maxlength":"16","labelWidth":"135px","reg":[
          {
            message: '请输入不含税金额',
            required: true
          },
          {
            pattern: /^\d+(\.\d{2})?$/,
            message: '请输入正确的金额',
            required: true,
          },
        ]},model:{value:(_vm.form.totalAmount),callback:function ($$v) {_vm.$set(_vm.form, "totalAmount", $$v)},expression:"form.totalAmount"}}):_c('Input',{attrs:{"label":"校验码后6位","maxlength":"6","placeholder":"请输入校验码后6位","type":"text","labelWidth":"95px","reg":[
            {
              pattern: /^[0-9a-zA-Z]{6}$/,
              message: '请填写正确的校验码后6位',
              required: true
            }
          ]},model:{value:(_vm.form.checkCode),callback:function ($$v) {_vm.$set(_vm.form, "checkCode", $$v)},expression:"form.checkCode"}}),_c('DataPicker',{attrs:{"label":"开票日期","placeholder":"选择开票日期","errorMessage":"请选择正确的开票日期","maxDate":_vm.maxDate,"minDate":_vm.minDate},model:{value:(_vm.form.billingDate),callback:function ($$v) {_vm.$set(_vm.form, "billingDate", $$v)},expression:"form.billingDate"}}),_c('div',{staticClass:"buttonGroup"},[_c('van-button',{staticClass:"goBack",on:{"click":_vm.goBack}},[_vm._v("返回")]),_c('van-button',{staticClass:"continueUpload",attrs:{"type":"danger"},on:{"click":_vm.onUpload}},[_vm._v("点击上传")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }